import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from './userContext';
import clsx from 'clsx';
import logo from '../images/logo-light.png';
import { 
  BrowserRouter as Router, 
  Link,
  NavLink,
  Redirect, 
  useHistory,  
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { 
  AppBar, 
  Box, 
  CssBaseline, 
  Container,
  IconButton, 
  Slide,
  Toolbar, 
  Typography, 
  useScrollTrigger 
} from '@material-ui/core';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import SportsEsportsRoundedIcon from '@material-ui/icons/SportsEsportsRounded';
import TheatersRoundedIcon from '@material-ui/icons/TheatersRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import MoreVertRoundedIcon from '@material-ui/icons/MoreVertRounded';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import Dashboard from './dashboard';
import BannerExample from '../pages/home';
import { auto } from 'async';
import Content from './content';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: 'rgba(30,30,30,1)',
    }
  },
  root: {
    // overflowX: 'hidden',
    position: 'sticky',
    top: 0,
    minWidth: 318,
    zIndex: 1201,
    display: 'flex',
    // position: 'fixed',
    '& .MuiPaper-root': {
      backgroundColor: 'rgba(34,34,34,1)',
      boxShadow: 'none'
    },
    padding: 0,
    // boxShadow: '0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%)'
    // '& .MuiPaper-elevation4': {
    //   boxShadow: '0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%)'
    // }
  },
  toolbar: {
    padding: theme.spacing(0, 5),
    '@media (max-width:599px)': {
      minHeight: '48px',
      padding: theme.spacing(0, 3),
    },
    '@media (min-width:600px)': {
      minHeight: '56px'
    }
  },
  container: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  clairvoyant: {
    height: 'auto',
    '@media (max-width:599px)': {
      maxWidth: '215px',
      width: '100%',
      minWidth: '185px'
    },
    '@media (min-width:600px)': {
      maxWidth: '250px',
    }
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:599px)': {
      height: '48px'
    },
    '@media (min-width:600px)': {
      height: '56px'
    }
  },
  megaLink: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 65,
    fontSize: '16px',
    fontWeight: 400,
    textDecoration: 'none',
    color: '#fff',
    '& span': {
      height: '56px',
      lineHeight: '56px'
    },
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
    '@media (max-width:599px)': {
      padding: '8px 16px',
      textAlign: 'center',
      '& .MuiSvgIcon-root': {
        display: 'inline-flex',
        alignSelf: 'center',
        marginRight: 8
      },
      '& span': {
        height: 40,
        lineHeight: '40px',
        display: 'inline-flex',
      },
    },
    '&:hover': {
      color: 'rgba(179, 102, 255, 1)',
      '& span:after': {
        transform: 'scaleX(1)',
      }
    }
  },
  activeMegaLink: {
    color: 'rgb(163, 102, 255)',
    fontWeight: 450,
    '@media (min-width:600px)': {
      '& span:after': {
        // transition: 'transform 500ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        transform: 'scaleX(1)',
      }
    },
  },
  megaMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '-12px',
    '@media (max-width:599px)': {
      flexDirection: 'column',
      position: 'absolute',
      top: '48px',
      left: '-100%',
      width: '100%',
      marginRight: 0,
      paddingTop: '30px',
      transition: 'all 0.5s ease',
      height: `calc(100vh - 48px)`,
      backgroundColor: 'rgba(26, 26, 26, 1)',
    }
  },
  megaMenuShift: {
    // display: 'flex',
    // flexDirection: 'row',
    // alignItems: 'center',
    // marginRight: '-10px',
    '@media (max-width:599px)': {
      // flexDirection: 'column',
      // position: 'absolute',
      // top: '48px',
      left: 0,
      // width: '100%',
      // marginRight: 0,
      // transition: 'all 0.5s ease',
      // height: `calc(100vh - 48px)`,
      // backgroundColor: 'rgba(34,34,34,1)',
    }
  },
  mobileIcon: {
    display: 'none',
   '@media (max-width:599px)': {
      display: 'flex',
    }, 
  },
  hide : {
    display: 'none'
  },
  iconButtonPadding: {
    padding: '8px',
    marginRight: '-8px'
  },
}));

export default function Main() {
  const classes = useStyles();
  const { user, setUser, pathName, setPathName } = useContext(UserContext);
  const [ click, setClick ] = useState(false);
  
  const handleToogle = () => {
    setClick(!click)
  }

  const handleClose = (event) => {
    setPathName(event.currentTarget.name)
    setClick(false)
  }

  return (
    <React.Fragment>
      <Router>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar 
            style={{width: '100%'}}
            color='inherit'
            position='sticky'
          >
            <Toolbar classes={{ regular: classes.toolbar }}>
              <Link to='/' name='/' onClick={handleClose} className={classes.logoContainer}><img src={logo} width={350} height={56} className={classes.clairvoyant} /></Link>
              <div style={{flexGrow: 1}} />
              <IconButton 
                onClick={handleToogle}
                className={classes.mobileIcon}
                classes={{ root: classes.iconButtonPadding }}
              >
                {click ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
              </IconButton>
              <div className={clsx(classes.megaMenu, {[classes.megaMenuShift] : click})}>
                <NavLink exact to='/' name='/' onClick={handleClose} className={classes.megaLink} activeClassName={classes.activeMegaLink}>
                  <span className="nav-link"><HomeRoundedIcon />Home</span>
                </NavLink>
                <NavLink exact to='/movies' name='/movies' onClick={handleClose} className={clsx(classes.megaLink, pathName.match('/movies') || pathName.match('/movie/detail') ? classes.activeMegaLink : null)}>
                  <span className="nav-link"><SportsEsportsRoundedIcon />Movies</span>
                </NavLink>
                <NavLink exact to='/games' name='/games' onClick={handleClose} className={clsx(classes.megaLink, pathName.match('/games') || pathName.match('/game/detail') ? classes.activeMegaLink : null)}>
                  <span className="nav-link"><TheatersRoundedIcon />Games</span>
                </NavLink>
                {
                  user ?
                    <></>
                  :
                    <NavLink exact to='/user/signin' onClick={handleClose} className={classes.megaLink} activeClassName={classes.activeMegaLink}>
                      <span className="nav-link"><LockOpenRoundedIcon />Sign&nbsp;In</span>
                    </NavLink>
                }
              </div>
            </Toolbar>
          </AppBar>
        </div>
        <div>
          <Dashboard />
        </div>
      </Router>
    </React.Fragment>
  );
}